import { API_HOST_DATA_PORTAL, API_HOST_ORGS } from "../config";
import { DataPortalLookupService } from "./DataPortalLookupService";
import { AwardingOrgService } from "./AwardingOrgService";
import { SasTokenService } from "./SasTokenService";

export const aoServiceRefData = new AwardingOrgService(API_HOST_ORGS);

export const dataPortalLookupService = new DataPortalLookupService(
  API_HOST_DATA_PORTAL
);

export const sasTokenService = new SasTokenService(API_HOST_DATA_PORTAL);
